// Chevron — THE open/close marker. One component, so there cannot be a second one.
//
// Alex, 2026-08-13, on finding two of them: "Is it the chevron that open close
// something. If yes, it must be the same."
//
// It was not. Two mechanisms, two shapes, two sizes, for one job:
//   TreeNav        a bare `›` rotated 90° by CSS, at var(--fs-body)
//   SectionTitle   `▾` / `▸` swapped as two glyphs, inheriting the TITLE font
//   ProjectsView   the same two glyphs again, inside a template string
//
// And the two glyphs were CROSSED with a second meaning — `›` was also the path
// separator in Breadcrumb (both densities), `▸` also the separator in OnshapePanel.
// Two shapes, each doing two jobs. Alex's call: open/close is `›` (the tree keeps
// what it had, being the control he uses all day), and the SEPARATOR takes `▸`.
//
// ⚠ A COMPONENT, NOT A CONSTANT, because a constant is what the last two had. Both
// call sites already imported the same glyph names from icons.js and still drifted
// on rotation and size, since a name only standardises the SHAPE — the behaviour
// and the size lived at each call site. Owning all three here is what makes a third
// variant hard to write instead of merely discouraged.
//
// Size is fixed at var(--fs-body) in a 14px box: the tree's existing geometry, which
// is the answer to UX-29 ("can the Onshape section chevron be the same or same size
// than the one in the tree").
import { DISCLOSURE } from '../icons.js';

export default function Chevron({ open = false, style = null }) {
  return (
    <span
      aria-hidden="true"
      style={{
        fontSize: 'var(--fs-body)', width: 14, flexShrink: 0,
        display: 'inline-block', userSelect: 'none', lineHeight: 1,
        ...style,
      }}
    >
      <span style={{
        display: 'inline-block', lineHeight: 1,
        transform: open ? 'rotate(90deg)' : 'none',
        transition: 'transform 0.15s',
      }}>{DISCLOSURE}</span>
    </span>
  );
}
